<template>
<div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box-entity">
        <div class="content">
            <div>
                <div class="container">
                    <div class="handle-box">

                        <el-select v-model="query.country" allow-create filterable clearable :filter-method="customFilter" style="width: 120px;" placeholder="国家" @clear="handleClear" @change="handleChange">
                            <el-option v-for="item in filteredOptions" :key="item.id" :label="item.title" :value="item.title">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.region" allow-create filterable clearable style="width: 120px;" placeholder="一级地区" @change="handleChange2">
                            <el-option v-for="item in regionlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.region2" allow-create filterable clearable style="width: 120px;" placeholder="二级地区">
                            <el-option v-for="item in region2list" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-input v-model="query.chinese" style="width: 100px;" placeholder="中文名称" class="handle-input"></el-input>
                        <el-input v-model="query.english" style="width: 120px;" placeholder="其它语言名称" class="handle-input"></el-input>
                        <el-select v-model="query.religion" allow-create filterable clearable style="width: 90px;" placeholder="宗教">
                            <el-option v-for="item in religionlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.party" style="width: 100px;" allow-create clearable filterable placeholder="派别">
                            <el-option v-for="item in partylist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.type" style="width: 120px;" allow-create clearable filterable placeholder="经营性质">
                            <el-option v-for="item in typelist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-input v-model="query.url" style="width: 120px;" placeholder="网站" class="handle-input "></el-input>
                        <el-input v-model="query.address" style="width: 150px;" placeholder="地址" class="handle-input "></el-input>
                        <el-input v-model="query.email" style="width: 140px;" placeholder="邮箱" class="handle-input "></el-input>
                        <el-input v-model="query.tel" style="width: 140px;" placeholder="电话" class="handle-input "></el-input>
                        <el-input v-model="query.contact" style="width: 150px;" placeholder="其它联系方式" class="handle-input "></el-input>
                        <el-input v-model="query.relation" style="width: 140px;" placeholder="隶属" class="handle-input "></el-input>
                        <el-select v-model="query.language" style="width: 120px;" allow-create clearable filterable placeholder="语言">
                            <el-option v-for="item in languagelist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                        <el-select v-model="query.status" style="width: 120px;" clearable filterable placeholder="审核状态">
                            <el-option v-for="item in statuslist" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" style="margin: 5px; width: 120px;" @click="handleSearch">搜索</el-button>
                    </div>
                    <div class="filter-container-right">

                        
                        <el-button><p>{{ formattedPrice }}</p></el-button>
                        <el-button v-waves class="filter-item" style="margin-left: 5px; width: 120px;" type="primary" icon="el-icon-message" @click="sendEmail">
                            发送邮件
                        </el-button>

                    </div>

                    <el-table :data="tableData" border fit style="width: 100%;" class="table" ref="table" header-cell-class-name="table-header" size="mini" v-loading="listLoading" row-class-name="success-row" stripe :cell-style="changColor" @selection-change="handleRowSelect" @row-click="handleClick">
                        <el-table-column prop="selects" type="selection" label="选择" width="50" align="center" />
                        <el-table-column type="index" width="50" label="序号" align="center" fixed />
                        <el-table-column prop="country" label="国家" align="center" fixed></el-table-column>
                        <el-table-column prop="region" label="一级地区" align="center" fixed></el-table-column>
                        <el-table-column prop="region2" label="二级地区" align="center" fixed></el-table-column>
                        <el-table-column prop="chinese" label="中文名称" width="120" align="center" fixed></el-table-column>
                        <el-table-column prop="english" label="其它语言名称" width="120" align="center" fixed></el-table-column>
                        <el-table-column prop="language" label="语言" width="100" align="center"></el-table-column>
                        <el-table-column prop="religion" label="宗教" width="100" align="center"></el-table-column>
                        <el-table-column prop="party" label="派别" align="center"></el-table-column>
                        <el-table-column prop="type" label="经营性质" width="100" align="center"></el-table-column>
                        <el-table-column prop="relation" label="隶属于" width="120" align="center"></el-table-column>
                        <el-table-column prop="google" label="Google地图" width="300" show-overflow-tooltip>
                            <template #default="scope">
                                <a :href="scope.row.google" target="_blank" style="text-decoration: none">
                                    {{ scope.row.google }}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="地址" align="center" width="400"></el-table-column>
                        <el-table-column prop="tel" label="电话" width="120" align="center"></el-table-column>
                        <el-table-column prop="email" label="邮箱" align="center" width="400"></el-table-column>
                        <el-table-column prop="url" label="网站" align="center" width="400"></el-table-column>
                        <el-table-column prop="contact" label="其他联系方式" width="150" align="center"></el-table-column>
                        <el-table-column prop="businesshours" label="营业时间" width="150" align="center"></el-table-column>
                        <el-table-column prop="person" label="接洽人" width="150" align="center"></el-table-column>
                        <el-table-column prop="link" label="接洽人联系方式" width="150" align="center"></el-table-column>
                        <el-table-column prop="count" label="拜访次数" width="150" align="center"></el-table-column>
                        <el-table-column prop="remark" label="备注" width="140" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="status" label="审核状态" width="150" align="center"></el-table-column>

                    </el-table>
                    <select-email ref="selectEmail" @addRefresh="addRefresh" />

                    <div class="pagination">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.pageNo" :page-sizes="[10,20,50,100,500]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog class="drawer-title" title="载体清单" :visible.sync="dialogFormVisible" width="450px" center>
        <div style="text-align: center;">

        </div>
    </el-dialog>
</div>
</template>

<script>
import vHeader from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import addDetail from './addDetail';
import selectEmail from './selectEmail'
import {
    entity_list_page,
    entity_post_email,
    entity_list_all,
    entity_list_getEmailCount,
    //importEntity,
    country_list_all,
    entity_del,
    entity_del_all,
    entity_list_getReligion,
    entity_list_getLanguage,
    entity_list_getParty,
    entity_list_getRegion,
    entity_list_getRegion2,
    entity_list_getType,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion,
    admin_forum_move,
    admin_users_type_seeTypes,
    admin_type_getlist
} from '../../api';
import {
    dealResult
} from "../../api/common";
export default {
    name: "AdminEmail",
    components: {
        vHeader,
        vSidebar,
        addDetail,
        selectEmail
    },
    data() {
        const confirmEndDate = (rule, str, callback) => {
            if (str === null || typeof str === "undefined" || str === "" || str === "0") {
                callback("请输入结束时间");
            } else if (str < this.topbestData.start) {
                callback('结束时间错误!');
            } else {
                callback();
            }
        };
        return {
            delMsgli: ["广告", "心术不正", "言辞不雅"],
            delVisible: false,
            delData: {},
            files: null,
            decimalPart: '', // 小数点后的字符
            msg: null,
            moveVisible: false,
            listLoading: false,
            FILE_ACTION: '',
            filteredOptions: [], // 用于存储过滤后的选项

            lander: {},
            trashNum: 0,
            typelist: [],
            countrylist: [],
            regionlist: [],
            region2list: [],
            religionlist: [],
            languagelist: [],
            statuslist: [{
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            partylist: [],
            tableData: [],
            contypelist: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }

            ],
            deleteSeleteData: {},
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            pageTotal: 0,
            emailCount: 0,

            topbestVisible: false,
            dialogFormVisible: false,
            topbestData: {
                id: '',
                start: '',
                end: '',
            },
            
            topbestDataRule: {
                start: [{
                    required: true,
                    message: '不能为空',
                    trigger: 'blur'
                }],
                end: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },
                    {
                        validator: confirmEndDate,
                        trigger: ["change", "blur"]
                    }
                ],
            },
            
        };
    },
     computed: {
    formattedPrice() {
      return `当前筛选条件有邮箱: ${this.emailCount} 个`;
    },
  },
    methods: {

        addRefresh() {
            this.reload()
        },

        // 刷新数据
        reload() {
            this.handleSearch()
        },

        
        

        changColor({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex === 23 && row.status === '是') {
                return {
                    color: 'green'
                }
            }
            if (columnIndex === 23 && row.status === '否') {
                return {
                    color: 'red'
                }
            }

        },

        handleClick(row) {
            this.$refs.table.toggleRowSelection(row)
        },

        // 查询操作
        handleSearch() {

            this.query.pageNo = 1;
            this.getPage();
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageNo = val;
            this.getPage();
        },
        handleSizeChange(val) {
            this.query.pageNo = 1;
            this.query.pageSize = val;
            this.getPage();
        },

        // 删除行
        handleDelete(row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                entity_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },
        handleRowSelect(selectionChange) {
            this.deleteSeleteData = selectionChange
        },

        //获取列表数据
        getPage() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            entity_list_page(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.tableData = res.data.obj.list
                    this.pageTotal = res.data.obj.total //该页总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false

            })

            entity_list_getEmailCount(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.emailCount = res.data.msg //总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }

            })

        },

        //获取列表数据
        sendEmail() {
            this.$confirm('此操作将发送邮件给以上查询条件筛选出的邮箱地址, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {

                this.$refs.selectEmail.open().then((that) => {
                that.initData(this.query, 'select')
            })
          
            })
        },
        //去重获取列表数据
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            entity_list_getReligion(this.query).then((res) => {
                this.religionlist = res.data.obj
            })
            entity_list_getLanguage(this.query).then((res) => {
                this.languagelist = res.data.obj
            })
            entity_list_getParty(this.query).then((res) => {
                this.partylist = res.data.obj
            })
            entity_list_getRegion(this.query).then((res) => {
                this.regionlist = res.data.obj
            })
            entity_list_getType(this.query).then((res) => {
                this.typelist = res.data.obj
            })
        },
        handleChange() {
            this.regionlist = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },
        handleChange2() {
            this.region2list = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            region_list_getRegion2ByRegion(this.query).then((response) => {
                this.region2list = response.data.obj
            })
        },
        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;

            country_list_all(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                    // this.pageTotal = res.data.obj.total //该页总共多少条记录

                } else {
                    this.$message.error(res.data.msg)
                }
                // 初始化时显示所有选项
                this.filteredOptions = this.countrylist;

            })
        },
        customFilter(query) {
            const lowerQuery = query

            // 区分开头匹配和非开头匹配
            const startsWithMatches = this.countrylist.filter(
                item => item.title.startsWith(lowerQuery)
            );
            const containsMatches = this.countrylist.filter(
                item =>
                item.title.includes(lowerQuery) &&
                !item.title.startsWith(lowerQuery)
            );

            // 合并结果，开头匹配在前
            this.filteredOptions = [...startsWithMatches, ...containsMatches];
        },
        handleClear() {
            this.getCountry(); // 确保清空输入框的值
        }

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        //去后端查询所有的用户给tableData赋值
        this.getPage();
        this.getCountry();
        this.getItems();
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.faceimg = this.lander.faceimg;
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/entity/entitylist/importExcel?uid=' + this.lander.uid + "&token=" + this.lander.token;
        if (this.lander.role == '100') {

        }
        if (this.lander.role == '50') {

        }

    }
}
</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
    width: 150px;
}

.content-box-entity {
    position: absolute;
    left: 200px;
    right: 0;
    top: 0px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
}

.filter-container-right {
    float: right;
}

.pagination {
    display: inline-block;
    padding-left: 200px;
    margin: 20px 0;
    border-radius: 4px;
}

.drawer-item {
    color: rgba(0, 0, 0, .65);
    font-size: 16px;
    padding: 12px 0;
}

.drawer-title {
    margin-bottom: 1px;
    margin-top: 15px;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 22px;
}

/*滚动条的宽度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

/*滚动条滑块*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 3px;
}
</style>
